import { Outlet, RouteObject } from "react-router-dom";
import { CrmModuleOr404 } from "@/shared/modules";
import {
  Counterparties,
  COUNTERPARTIES_PATH,
} from "@/modules/crm/pages/counterparties";
import {
  COUNTERPARTY_TAGS_LIST_PATH,
  CounterpartyTagsList,
} from "@/modules/crm/pages/counterparty-tag-list";
import {
  OPPORTUNITIES_PATH,
  OpportunitiesPage,
} from "@/modules/crm/pages/oportunities";
import {
  SAVE_OPPORTUNITIES_PATH,
  SaveOpportunitiesPage,
} from "@/modules/crm/pages/save-opportunities";
import {
  OPPORTUNITY_PATH,
  OpportunityPage,
} from "@/modules/crm/pages/opportunity";
import { PRODUCTS_PATH, ProductsPage } from "@/modules/crm/pages/products";
import {
  SAVE_PRODUCT_PATH,
  SaveProductPage,
} from "@/modules/crm/pages/save-products";
import {
  SALES_FUNNEL_PATH,
  SalesFunnelPage,
} from "@/modules/crm/pages/sales-funnel";
import {
  CRM_DOCUMENT_REGISTER_PATH,
  CrmDocumentRegisterPage,
} from "@/modules/crm/pages/document-register";
import { COUNTERPARTY_PATH } from "@/modules/crm/pages/counterparty/path";
import { CounterpartyPage } from "@/modules/crm/pages/counterparty";
import {
  CRM_DOCUMENT_PATH,
  CrmDocumentPage,
} from "@/modules/crm/pages/crm-document";

export const crmRoutes: RouteObject[] = [
  {
    element: (
      <CrmModuleOr404>
        <Outlet />
      </CrmModuleOr404>
    ),
    children: [
      {
        path: COUNTERPARTIES_PATH,
        element: <Counterparties />,
      },
      {
        path: COUNTERPARTY_PATH,
        element: <CounterpartyPage />,
      },
      {
        path: COUNTERPARTY_TAGS_LIST_PATH,
        element: <CounterpartyTagsList />,
      },
      {
        path: OPPORTUNITIES_PATH,
        element: <OpportunitiesPage />,
      },
      {
        path: SAVE_OPPORTUNITIES_PATH,
        element: <SaveOpportunitiesPage />,
      },
      {
        path: OPPORTUNITY_PATH,
        element: <OpportunityPage />,
      },
      {
        path: PRODUCTS_PATH,
        element: <ProductsPage />,
      },
      {
        path: SAVE_PRODUCT_PATH,
        element: <SaveProductPage />,
      },
      {
        path: SALES_FUNNEL_PATH,
        element: <SalesFunnelPage />,
      },
      {
        path: CRM_DOCUMENT_REGISTER_PATH,
        element: <CrmDocumentRegisterPage />,
      },
      {
        path: CRM_DOCUMENT_PATH,
        element: <CrmDocumentPage />,
      },
    ],
  },
];
